export default __webpack_public_path__ + "static/media/Uae_consultation_completed.32ac789b.svg";